import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { SystemApiService } from '@cv-invision/core';

@Injectable()
export class AppScopeService {

	private readonly BASE_URL = '/utils';

	constructor(private httpClient: HttpClient, private systemApiService: SystemApiService) {
		// Silence is golden.
	}

	/**
	 * GET - Return the list of available app-scope property types
	 */
	getPropertyTypes(): Observable<any> {
		return this.httpClient.get(
			`${this.systemApiService.api.orders}${this.BASE_URL}/appscope/property-types`);
	}

	/**
	 * GET - Return the list of available app-scope loan types
	 */
	getLoanTypes(): Observable<any> {
		return this.httpClient.get(
			`${this.systemApiService.api.orders}${this.BASE_URL}/appscope/loan-types`);
	}

	/**
	 * GET - Return the list of available app-scope loan types
	 */
	getLoanReasons(): Observable<any> {
		return this.httpClient.get(
			`${this.systemApiService.api.orders}${this.BASE_URL}/appscope/loan-reasons`);
	}

	/**
	 * GET - Return the list of available app-scope occupancy types
	 */
	getOccupancyTypes(): Observable<any> {
		return this.httpClient.get(
			`${this.systemApiService.api.orders}${this.BASE_URL}/appscope/occupancy-types`);
	}

}
